// ─────────────────────────────────────────────────────────────────────────────
// RequireModule.js — Guards a route behind RBAC module access.
//
// Complements ProtectedRoute (which checks the token). Once authenticated, this
// blocks direct navigation to a module the current role has no access to (None),
// so typing the URL is stopped the same way the sidebar hides the link. Assumes
// an ancestor ProtectedRoute has already enforced authentication.
// ─────────────────────────────────────────────────────────────────────────────
import { Navigate } from "react-router-dom";
import { usePermissions } from "../features/auth/model/usePermissions";

export default function RequireModule({ module, children }) {
  const { canAccess } = usePermissions();

  if (!canAccess(module)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
